import { commonjsGlobal as e } from "../../_virtual/_commonjsHelpers.js";
var r, o;
function t() {
  if (o) return r;
  o = 1;
  var a = typeof e == "object" && e && e.Object === Object && e;
  return r = a, r;
}
export {
  t as __require
};
